if(!customElements.get('cw-construction-carousel')){
  customElements.define('cw-construction-carousel',class extends HTMLElement{
    connectedCallback(){
      this.lifecycle?.abort();
      this.lifecycle=new AbortController();
      const signal=this.lifecycle.signal;
      this.rail=this.querySelector('.choices');
      this.cards=Array.from(this.querySelectorAll('.choices>[data-kind]'));
      this.tabs=Array.from(this.querySelectorAll('[data-cwcc-view]'));
      this.mobile=matchMedia('(max-width:700px)');
      if(!this.rail || !this.cards.length)return;
      this.activeIndex=0;
      this.tabs.forEach((button,index)=>{
        button.addEventListener('click',()=>this.show(index),{signal});
        button.addEventListener('keydown',event=>{
          let next=index;
          if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;
          else if(event.key==='ArrowLeft')next=(index+this.tabs.length-1)%this.tabs.length;
          else if(event.key==='Home')next=0;
          else if(event.key==='End')next=this.tabs.length-1;
          else return;
          event.preventDefault();this.tabs[next].focus();this.show(next);
        },{signal});
      });
      this.rail.addEventListener('scroll',()=>{
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame=requestAnimationFrame(()=>{
          if(!this.mobile.matches)return;
          const railLeft=this.rail.getBoundingClientRect().left;
          const distances=this.cards.map(card=>Math.abs(card.getBoundingClientRect().left-railLeft));
          this.sync(distances.indexOf(Math.min(...distances)));
        });
      },{signal,passive:true});
      this.rail.addEventListener('focusin',event=>{
        if(!this.mobile.matches)return;
        const card=event.target.closest('[data-kind]');
        const index=this.cards.indexOf(card);
        if(index>=0)this.show(index,false);
      },{signal});
      this.mobile.addEventListener('change',()=>this.layout(),{signal});
      this.resize=new ResizeObserver(()=>{
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame=requestAnimationFrame(()=>this.layout());
      });
      this.resize.observe(this.rail);
      this.initFrame=requestAnimationFrame(()=>{
        const selected=this.cards.findIndex(card=>card.classList.contains('is-selected'));
        this.activeIndex=selected>=0?selected:0;
        this.layout();
      });
    }
    sync(index){
      this.activeIndex=index;
      this.tabs.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
      this.dataset.activeView=this.cards[index]?.dataset.kind || 'frameless';
    }
    show(index,smooth=true){
      if(!this.mobile.matches)return;
      const card=this.cards[index];
      if(!card)return;
      this.sync(index);
      const left=card.getBoundingClientRect().left-this.rail.getBoundingClientRect().left+this.rail.scrollLeft;
      this.rail.scrollTo({left,behavior:smooth && !matchMedia('(prefers-reduced-motion:reduce)').matches?'smooth':'instant'});
    }
    layout(){
      this.classList.add('is-carousel-ready');
      if(this.mobile.matches)this.show(this.activeIndex,false);
      else this.rail.scrollLeft=0;
    }
    disconnectedCallback(){
      this.lifecycle?.abort();this.resize?.disconnect();
      cancelAnimationFrame(this.initFrame);cancelAnimationFrame(this.scrollFrame);cancelAnimationFrame(this.resizeFrame);
    }
  });
}
